import "./ProjectCardsStyles.css";

import React from "react";

import { NavLink } from "react-router-dom";

const ProjectCards = (props) => {
  return (
    <div className="project-card">
      <img className="pic" src={props.imgsrc} alt="img/" />
      <h2 className="project-title">{props.title}</h2>
      <div className="pro-details">
        <p>{props.text}</p>
        <div className="pro-btns">
          <NavLink to={props.view} className="btn" target="_blank">
            View
          </NavLink>
          {/* <NavLink to="url.com" className="btn"> */}
          {/* Source */}
          {/* </NavLink> */}
        </div>
      </div>
    </div>
  );
};

export default ProjectCards;
